module.exports = __webpack_public_path__ + "img/mockup-simplyfancy.065715dd.png";